<section id="home" class="section welcome-area bg-overlay overflow-hidden d-flex align-items-center">
    <div class="container">
        <div class="row align-items-center">
            <!-- Welcome Intro Start -->
            <div class="col-12 col-md-7 col-lg-6">
                <div class="welcome-intro">
                    <h1 class="text-white" style="font-size: 2.5rem !important;">Wellness integral, a la medida y en un
                        sólo lugar
                    </h1>
                    <p class="text-white my-4">En Bonavida somos expertos en Wellness. Nuestros programas de salud y
                        bienestar para colaboradores se adaptan a las necesidades de nuestros clientes. Nos basamos en
                        la ciencia y la constante investigación para desarrollar una cultura organizacional saludable
                        que integra las 7 partes de Wellness y que permite que los colaboradores se sientan felices,
                        motivados, saludables e integrados.
                    </p>
                    <!-- Store Buttons -->
                    <div class="button-group store-buttons d-flex">
                        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.bonavida.gt">
                            <img src="assets/img/google-play.png" alt="">
                        </a>
                        <a target="_blank" href="https://apps.apple.com/lv/app/bonavida/id1598738341">
                            <img src="assets/img/app-store.png" alt="">
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-5 col-lg-6">
                <!-- Welcome Thumb -->
                <div class="welcome-thumb mx-auto" data-aos="fade-left" data-aos-delay="500" data-aos-duration="1000">
                    <img src="assets/img/welcome_mockup.png" alt="">
                </div>
            </div>
        </div>
    </div>
    <!-- Shape Bottom -->
    <div class="shape-bottom">
        <svg viewBox="0 0 1920 310" version="1.1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" class="svg replaced-svg">
            <title>Bonavida</title>
            <defs></defs>
            <g id="sApp-Landing-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="sApp-v1.0" transform="translate(0.000000, -554.000000)" fill="#FFFFFF">
                    <path
                        d="M-3,551 C186.257589,757.321118 319.044414,856.322454 395.360475,848.004007 C509.834566,835.526337 561.525143,796.329212 637.731734,765.961549 C713.938325,735.593886 816.980646,681.910577 1035.72208,733.065469 C1254.46351,784.220361 1511.54925,678.92359 1539.40808,662.398665 C1567.2669,645.87374 1660.9143,591.478574 1773.19378,597.641868 C1848.04677,601.75073 1901.75645,588.357675 1934.32284,557.462704 L1934.32284,863.183395 L-3,863.183395"
                        id="sApp-v1.0"></path>
                </g>
            </g>
        </svg>
    </div>
</section>